import Http from "../commons/utils/Http";
import {errorHandling} from "../commons/utils/error";

class rolesService {

    async getAll(page) {
        try {
            let response = await Http.get(`/roles/get-all?offset=${page}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getId(id) {
        try {
            let response = await Http.get(`/roles/get-by?field=id&value=${id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getByApplication(application_id, page) {
        try {
            let response = await Http.get(`/roles/get-by?field=application_id&fetch=all&value=${application_id}&page=${page}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async search(body) {
        try {
            let response = await Http.post(`/roles/search/rolesapplication`, body,Http.headers);
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getApplicationsRoles() {
        try {
            let response = await Http.get(`/roles/roles-and-applications`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async insert(data) {
        try {
            let response = await Http.post(`/roles`, data,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async update(data) {
        try {
            let response = await Http.put(`/roles`, data,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async delete(id) {
        try {
            let response = await Http.delete(`/roles/${id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async saveRoleModules(data) {
        try {
            let response = await Http.post(`/roles/save-role-modules`, data,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

}

export default new rolesService();